import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import DraggableTable from "../../../components/draggable-table/DraggableTables";


class EventsDetails extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            licenseNumbers: { options: [], loadingD: false },
            events: [],
            table: {},
            alert: { msg: '', type: '' },
            loading: false,
            filter: {
                startPeriod: "",
                endPeriod: "",
                eventCodes: [],
                idDrivers: [],
                idVehicles: [],
            }

        }
    }




    componentDidMount() {
        this.getEvents();
    }

    getEvents = () => {
        axios
            .get(`${url}/v1/telemetria/admin/cache/eventGroup/${this.props.token}`)
            .then(d => {
                // console.log(d.data);
                let events = [];
                d.data.forEach(d => {
                    events.push({ value: d.code, label: d.name });
                });
                this.setState({ events });
            })
            .catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({loading: false})
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            });
    };

    getEventsDetail = () => {
        this.setState({ loading: true, table: {}, alert: { msg: '', type: '' } });
        axios
            .post(`${url}/v1/telemetria/admin/report/eventDetail/${this.props.token}`, this.state.filter)
            .then(d => {
                console.log(d)
                if (d.data.data.length) {
                    this.setState({ table: d.data, loading: false });
                } else {
                    this.setState({
                        loading: false,
                        alert: {
                            type: "",
                            msg:
                                "Não foi possivel localizar resultados para o período selecionado."
                        }
                    });
                }
                //console.log(d.data);
            })
            .catch(e => {
                console.log(e)
                var errorMsg = e.response.data.errorMessage
                this.setState({loading: false})
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };
    exportEventsDetail = () => {
        this.setState({ loading: true });
        const body = this.state.filter
        axios
            .request({
                url: `${url}/v1/telemetria/admin/report/eventDetail/export/${this.props.token}`,
                method: "POST",
                responseType: "blob", //important
                data: {
                    ...body,
                    columns: this.state.table.columns,
                    responseType: "blob"
                }
            })
            .then(({ data }) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement("a");
                link.href = downloadUrl;
                link.setAttribute(
                    "download",
                    `${body.eventCodes.length > 0
                        ? "_" + body.eventCodes
                        : "_report"
                    }-${body.startPeriod}--${body.endPeriod}.xls`
                ); //any other extension
                document.body.appendChild(link);
                link.click();
                link.remove();
                this.setState({ loading: false });
            })
            .catch(e => {
                console.log(e)
                var errorMsg = e.response.data.errorMessage
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
                // this.props.validateToken(this.props.token)
            })
    };

    getColumns = c => {
        var columns = c
        c.forEach((d, i) => {
            if (d.isNumeric) {
                columns[i] = { ...d, sorter: (a, b) => this.getVal(a, d.dataIndex) - this.getVal(b, d.dataIndex) }
                // columns[i] = {...d, sorter: (a, b) => this.valueColum(a, d.key)}
            }
            // if (this.fixedCols(d.title)) {
            //     columns[i] = { ...d, fixed: 'left', ellipsis: true, }
            // }
        });
        this.setState({
            table: {
                ...this.state.table,
                columns
            }
        });
    };

    fixedCols = key => {
        switch (key) {
            case 'MOTORISTA':
                return true
            case 'PLACA':
                return true
            default:
                break;
        }
    }

    getVal = (a, key) => {
        var val = Reflect.get(a, key)
        if (typeof val === "number") {
            return val
        } else {
            return val.replace(",", "").replace(".", "").replace("-", "0")
        }
    }

    renderToolbar = () => {
        return (
            <ToolBar>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, startPeriod: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, endPeriod: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.startPeriod}
                        min={this.state.filter.startPeriod}
                        max={getFDate()}
                    />
                </div>

                <div>
                    <label htmlFor="drivers" className='toolbar-label'>Motoristas</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='drivers'
                        isLoading={this.state.drivers.loading}
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Motoristas"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.drivers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idDrivers: [] } })
                            }
                            else {
                                let idDrivers = []
                                i.forEach(d => idDrivers.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idDrivers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                        this.setState({ drivers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="vehicles" className='toolbar-label'>Frotas</label>
                    {/* Select Frotas */}
                    <Select
                        inputId='vehicles'
                        isLoading={this.state.licenseNumbers.loadingD}
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Frotas"
                        className='toolbar-select'
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise as Frotas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.licenseNumbers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idVehicles: [] } })
                            }
                            else {
                                let idVehicles = []
                                i.forEach(d => idVehicles.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idVehicles } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ licenseNumbers: { ...this.state.licenseNumbers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/vehicles/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.licenseNmbr, value: d.vehicleId }))
                                        this.setState({ licenseNumbers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>
                <div>
                    <label htmlFor="groups" className='toolbar-label'>Eventos</label>

                    {/* Select Eventos */}
                    <Select
                        // isDisabled={this.state.loading}
                        // isLoading={this.state.collab.loading}
                        inputId='groups'
                        className='toolbar-select'
                        isMulti
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Eventos"
                        noOptionsMessage={e => { return `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.events}
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, eventCodes: [] } })
                            }
                            else {
                                let eventCodes = []
                                i.forEach(d => eventCodes.push(d.value))
                                this.setState({ filter: { ...this.state.filter, eventCodes } })
                            }
                        }}
                        isClearable
                        isDisabled={this.state.loading} />

                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getEventsDetail()}
                    disabled={!this.state.filter.startPeriod || !this.state.filter.endPeriod || this.state.loading}
                />

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.data ? (
                    <div>

                        <input
                            type="button"
                            value='Exportar Excel'
                            className='excel-button'
                            onClick={() => this.exportEventsDetail()}
                            style={{ marginBottom: '20px' }}
                            disabled={this.state.loading}
                        />
                        <DraggableTable
                            path={this.props.path.get}
                            table={this.state.table}
                            getColumns={this.getColumns}
                        />
                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default EventsDetails